import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationCheckService } from 'src/app/services/auth/authentication-check.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  showOtp = false;
  submitting = false;
  errorMessage = '';
  loginDetails: any = {};

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private formBuilder: FormBuilder,
    private auth: AuthenticationCheckService,
    private toast: ToastClientService
  ) {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{10}$')
      ])],
      otp: ['']
    });
    this.checkLogin();
  }

  ngOnInit() {
    document.body.classList.add('signin-page');
  }

  ngOnDestroy() {
    document.body.classList.remove('signin-page');
  }

  checkLogin() {
    const token = localStorage.getItem('auth-token');
    if (token) {
      this.router.navigate(['/catalogue/dashboard']);
    }
  }

  login() {
    this.errorMessage = '';
    if (!this.showOtp) {
      this.requestOtp();
      return;
    }
    this.verifyOtp();
  }

  requestOtp() {
    // let usernameControl = this.loginForm.get('username');
    this.loginForm.get('username').markAsTouched();
    if (this.loginForm.get('username').invalid) {
      return;
    }

    const payload = {
      mobile_no: this.loginForm.value.username
    };

    this.submitting = true;
    this.apiService.post(this.apiConfig.Login, payload)
      .subscribe((res: any) => {
        this.submitting = false;
        this.showOtp = true;
        const otpControl = this.loginForm.get('otp');
        otpControl.setValidators([
          Validators.required,
          Validators.pattern('^[0-9]{4,6}$')
        ]);
        otpControl.updateValueAndValidity();
        const body = res && res.body ? res.body : res;
        const data = body && body.data ? body.data : body;
        this.loginDetails = data || {};
        localStorage.setItem('login-details', JSON.stringify(this.loginDetails));
        const userId = this.userIdFrom(this.loginDetails);
        if (userId) {
          localStorage.setItem('uid', userId);
        }
        const message = (body && (body.message || (data && data.message))) || 'OTP sent successfully';
        this.toast.Success(message);
      }, () => {
        this.submitting = false;
      });
  }

  verifyOtp() {
    this.loginForm.get('otp').markAsTouched();
    if (this.loginForm.invalid) {
      return;
    }

    const hasLoginDetails = this.loginDetails && Object.keys(this.loginDetails).length;
    const details = hasLoginDetails
      ? this.loginDetails
      : JSON.parse(localStorage.getItem('login-details') || '{}');
    const payload = {
      mobile_num: this.loginForm.value.username,
      otp: this.loginForm.value.otp,
      program_id: this.programIdFrom(details),
      user_id: this.userIdFrom(details),
    
    };

    this.submitting = true;
    this.apiService.post(this.apiConfig.otpUrl, payload)
      .subscribe((res: any) => {
        this.submitting = false;
        const body = res && res.body ? res.body : res;
        const data = body && body.data ? body.data : body;
        localStorage.setItem('otp-details', JSON.stringify(data && typeof data === 'object' ? data : {}));
        const token = this.extractToken(body, data);
        if (!token) {
          this.errorMessage = 'Login failed. Token was not returned.';
          this.toast.Error(this.errorMessage);
          return;
        }

        this.auth.saveAuth(token).then(() => {
          localStorage.setItem('login', 'true');
          localStorage.setItem('user_name', this.loginForm.value.username);
          this.router.navigate(['/catalogue/dashboard']);
        });
      }, () => {
        this.submitting = false;
      });
  }

  programIdFrom(details) {
    if (!details) {
      return '';
    }
    return details.program_id || details.programId || '';
  }

  userIdFrom(details) {
    if (!details) {
      return '';
    }
    return details.userid || details.user_id || details.userId || details.uid || '';
  }

  extractToken(body, data) {
    const source = data || {};
    const raw = source.token || source.access_token || source.auth_token || source.authToken
      || (body && (body.token || body.access_token || body.auth_token));
    if (!raw) {
      return '';
    }
    return String(raw).replace(/^Bearer\s+/i, '');
  }

  isValid(field): boolean {
    const control = this.loginForm.controls[field];
    if (!control || control.touched === false) {
      return true;
    }
    return control.valid === true;
  }
}
